import { initialButtonRoleVisibilityState } from "./ButtonRoleVisibility.types";
import { LoadState } from "../../constants/enums";
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchButtonRoleVisibilityList,
  fetchButtonVisibilityRecord,
  fetchButtonVisibilityRecordByCode,
} from "./ButtonRoleVisibilityActions";

const buttonRoleVisibilitySlice = createSlice({
  name: "buttonRoleVisibility",
  initialState: initialButtonRoleVisibilityState,
  reducers: {
    clearButtonRoleVisibilityState: (state) => {
      return initialButtonRoleVisibilityState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchButtonRoleVisibilityList.pending, (state) => {
        state.data.loading = LoadState.InProgress;
        state.data.list = [];
      })
      .addCase(fetchButtonRoleVisibilityList.fulfilled, (state, action) => {
        state.data.loading = LoadState.Loaded;
        state.data.list = action.payload.data;
        state.data.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchButtonRoleVisibilityList.rejected, (state) => {
        state.data.loading = LoadState.Failed;
        state.data.list = [];
      })
      .addCase(fetchButtonVisibilityRecord.pending, (state, action) => {
        state.runtimeRefData[action.meta.arg] = {
          loading: LoadState.InProgress,
          record: null,
        };
      })
      .addCase(fetchButtonVisibilityRecord.fulfilled, (state, action) => {
        state.runtimeRefData[action.payload.code] = {
          loading: LoadState.Loaded,
          record: action.payload.record,
        };
      })
      .addCase(fetchButtonVisibilityRecord.rejected, (state, action) => {
        state.runtimeRefData[action.meta.arg] = {
          loading: LoadState.Failed,
          record: null,
        };
      })
      .addCase(fetchButtonVisibilityRecordByCode.pending, (state, action) => {
        state.runtimeRefData[action.meta.arg] = {
          loading: LoadState.InProgress,
          record: null,
        };
      })
      .addCase(fetchButtonVisibilityRecordByCode.fulfilled, (state, action) => {
        state.runtimeRefData[action.payload.code] = {
          loading: LoadState.Loaded,
          record: action.payload.record,
        };
      })
      .addCase(fetchButtonVisibilityRecordByCode.rejected, (state, action) => {
        state.runtimeRefData[action.meta.arg] = {
          loading: LoadState.Failed,
          record: null,
        };
      });
  },
});

export const { clearButtonRoleVisibilityState } =
  buttonRoleVisibilitySlice.actions;
export const ButtonRoleVisibilityReducer = buttonRoleVisibilitySlice.reducer;
